/**
 * State selector function
 *
 * @export
 * @interface StateSelector
 * @template T
 */
export type StateSelector = (state: any) => any;

/* old
export interface StateSelector {
    (state: any): any;
  }
*/

